export default __webpack_public_path__ + "static/media/sun.0b7ed9b3.png";